import React, { FC } from 'react';

import { Container } from 'src/components/Container';

type NoResultProps = {
  message?: string;
};

const NoResult: FC<NoResultProps> = ({ message = 'There is no result.' }) => {
  return (
    <Container textAlign="center" padding="5rem 0" color="inherit">
      {message}
    </Container>
  );
};

export default NoResult;
